module.exports = {
    DELETE_REMOTE_WORK: "Are you sure you want to delete this WFH Request?",
    DELETE_REMOTE_WORK_COMMENT: "Are you sure you want to delete this WFH comment?",
    DELETE_ATTACHMENT: "Are you sure you want to delete this WFH attachement?"
}